import React, { useState, useEffect } from "react"
import FormPopup from "./FormPopup";


//test
//https://api.telegram.org/bot7229815824:AAFd3AGDotsDsiuoU3qzJl6ezXk6WRVeF9w/sendMessage
//-4685858033

type props = {
    note?: string;
    head?: { title?: string, description?: string };
    children: any;
}

const AgentHelpPopup = ({ note, head, children }: props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [fields, setFields] = useState([
        { name: "fio", title: "Фио", require: true },
        { name: "phone", title: "Телефон", require: true },
    ])

    return (
        <>
            <div onClick={() => setIsOpen(true)}>{children}</div>

            <FormPopup
                fields={fields}
                isOpen={isOpen}
                close={() => setIsOpen(false)}
                head={{ title: head?.title || "Помощь агента", description: head?.description || "Оставьте заявку и наш сотрудник свяжется с вами" }}
                url={"https://api.telegram.org/bot7064703080:AAGVqAkyT6-Gy1Y-dMEf0XPM23Ci1lkvx88/sendMessage"}
                chatId={-1002061148970}
                noteText={note}
            />
        </>
    )
}

export default AgentHelpPopup;